import { render, staticRenderFns } from "./IconPlay.vue?vue&type=template&id=7b2774bf&"
import script from "./IconPlay.vue?vue&type=script&lang=ts&"
export * from "./IconPlay.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports